import { combineReducers, Reducer } from 'redux'
import { deviceReducer, deviceState } from './scanner/device';
import { reportReducer, reportState } from './scanner/report';
import { storeReducer, storeState } from './scanner/store';
import { silizhuReportReducer, silizhuReportState } from './silizhu/report';
import { styleReducer, styleState } from './style';
import { userReducer, userState } from './user'
import { silizhuStoreReducer, silizhuStoreState } from './silizhu/store';
import { silizhuAccountReducer, silizhuAccountState } from './silizhu/account';
import { silizhuExamineeReducer, silizhuExamineeState } from './silizhu/examinee';
import { silizhuAnimation, silizhuAnimationState } from './silizhu/animation';
import { silizhuStatisticsReducer, silizhuStatisticsState } from './silizhu/statistics';

export interface RootState {
    user: userState,
    store: storeState,
    device: deviceState,
    report: reportState,
    style: styleState,
    silizhuReport: silizhuReportState,
    silizhuStore: silizhuStoreState,
    silizhuAccount: silizhuAccountState,
    silizhuExaminee: silizhuExamineeState,
    silizhuAnimation: silizhuAnimationState,
    silizhuStatistics: silizhuStatisticsState,
}

export const rootReducer: Reducer<RootState> = combineReducers({
    'user': userReducer,
    'store': storeReducer,
    'device': deviceReducer,
    'report': reportReducer,
    'style': styleReducer,
    'silizhuReport': silizhuReportReducer,
    'silizhuStore': silizhuStoreReducer,
    'silizhuAccount': silizhuAccountReducer,
    'silizhuExaminee': silizhuExamineeReducer,
    'silizhuAnimation': silizhuAnimation,
    'silizhuStatistics': silizhuStatisticsReducer,
}) as any;